import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import List from 'containers/pages/calculatorManagement/dplkFee/List'
import Form from 'containers/pages/calculatorManagement/dplkFee/Form'

const CalcManagement = ({ location, match, currentUser }) => {
  if (location.pathname === '/calculator-management/biaya-dplk') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-calculator-managementbiaya-dplk-read') > -1) {
      return <List location={location} />
    }
    return <ForbiddenPage />
  }
  if (location.pathname.includes('/edit') || location.pathname.includes('/add')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-calculator-managementbiaya-dplk-write') > -1) {
      return <Form match={match} location={location} />
    }
    return <ForbiddenPage />
  }
  return ''
}

CalcManagement.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default CalcManagement
